import { HttpContextToken } from '@angular/common/http';

export const SKIP_FORBIDDEN_REDIRECT = new HttpContextToken<boolean>(() => false);
